import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ServiceSummaryRoutingModule} from 'src/app/main/service/service-summary/service-summary-routing.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {ServiceSummaryComponent} from './service-summary.component';
import {OverviewViewComponent} from './overview-view/overview-view.component';
import {ServiceTabsComponent} from './service-tabs-content/service-tabs-content.component';
import {TutorialCardModule} from 'src/app/main/service/tutorial-card/tutorial-card.module';
import {EndpointCardModule} from 'src/app/main/service/endpoint-card/endpoint-card.module';
import {IconsModule} from 'src/app/icons/icons.module';
import {PipesModule} from 'src/app/pipes/pipes.module';
import {BreadcrumbModule} from '../../../components/breadcrumb/breadcrumb.module';
import {UpgradePlanDialogModule} from '../upgrade-plan-dialog/upgrade-plan-dialog.module';
import {PlayButtonModule} from 'src/app/components/play-button/play-button.module';
import {CarouselModule} from 'src/app/components/carousel/carousel.module';
import {MatDividerModule} from '@angular/material/divider';
import {TutorialsDocumentsViewComponent} from './tutorials-documents-view/tutorials-documents-view.component';
import {FormsModule} from '@angular/forms';
import {CardModule} from '../card/card.module';
import {DocumentCardModule} from '../document-card/document-card.module';
import {CapabilityCardModule} from '../../../components/capability-card/capability-card.module';
import {FaqSectionModule} from 'src/app/components/faq-section/faq-section.module';
import {CreateSandboxDialogModule} from '../create-sandbox-dialog/create-sandbox-dialog.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    ServiceSummaryComponent,
    ServiceTabsComponent,
    OverviewViewComponent,
    TutorialsDocumentsViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    ServiceSummaryRoutingModule,
    TutorialCardModule,
    DocumentCardModule,
    EndpointCardModule,
    IconsModule,
    PipesModule,
    BreadcrumbModule,
    UpgradePlanDialogModule,
    CreateSandboxDialogModule,
    PlayButtonModule,
    CarouselModule,
    MatDividerModule,
    FormsModule,
    CardModule,
    CapabilityCardModule,
    FaqSectionModule,
    MatProgressSpinnerModule
  ]
})
export class ServiceSummaryModule { }
